<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="任务汇报关键信息">
        <div slot="content">
          <dynamic-form
            ref="form"
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
            v-loading="initloading"
          />
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" @click="submit">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import { addTaskReport, getTaskReportById } from "@/api/bill/taskReport";
export default {
  components: {
    FoldedPanel
  },
  data() {
    return {
      initloading: false,
      loading: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "documentNum",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
            // placeholder: "自动生成失败",
            // rules: [
            //   {
            //     required: true,
            //     message: "单据编号自动生成失败",
            //     trigger: "blur"
            //   }
            // ]
          },
          {
            type: "input",
            key: "projectNum",
            label: "项目号",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "input",
            key: "workAlloctionTime",
            label: "工作分配日期",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "input",
            key: "projectNode",
            label: "项目节点",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "input",
            key: "milestoneNode",
            label: "里程碑节点节点",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "input",
            key: "taskNodeNumber",
            label: "任务节点编号",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "textarea",
            key: "taskContent",
            label: "任务内容",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "textarea",
            key: "specificWork",
            label: "具体工作",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "input",
            key: "taskClass",
            label: "任务接收人",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "input",
            key: "ke",
            label: "可支配人天",
            value: "",
            span: 8,
            placeholder: "来源于任务分配",
            disabled: true
          },
          {
            type: "textarea",
            key: "workReport",
            label: "工作汇报",
            value: "",
            span: 16,
            placeholder: "请输入工作汇报",
            rules: [
              { required: true, message: "工作汇报不能为空", trigger: "blur" }
            ]
          },
          {
            type: "radio",
            key: "accomplishCondition",
            label: "完成",
            value: "N",
            span: 8,
            options: [
              { value: "N", label: "未完成" },
              { value: "Y", label: "已完成" },
            ]
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注",
            span: 16
          }
        ]
      }
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      if (!this.$route.query.id) {
        return;
      }
      this.initloading = true;
      try {
        const result = await getTaskReportById(this.$route.query.id);
        // console.log(result);
        const form = result.data;
        this.form = form;
        this.initloading = false;
      } catch (e) {
        this.initloading = false;
      }
    },
    submit() {
      this.$refs["form"].validate().then(() => {
        if (this.form.id) {
          this.doEdit();
        } else this.doAdd();
        this.cancel();
      });
    },
    doAdd() {
      this.loading = true;
      addTaskReport(this.form)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.cancel();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    doEdit() {
      this.loading = true;
      addTaskReport(this.form)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.cancel();
        })
        .catch(err => {
          this.loading = false;
          console.log(err.response.data.message);
        });
    },
    cancel() {
      this.$router.push("/taskReport");
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  padding-top: 20px;
  text-align: right;
  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }
  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
